import { render, staticRenderFns } from "./RelatorioGestaoPcaPofspa.vue?vue&type=template&id=1a3f7278"
import script from "./RelatorioGestaoPcaPofspa.vue?vue&type=script&lang=ts"
export * from "./RelatorioGestaoPcaPofspa.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports